export default __webpack_public_path__ + "static/media/tf.aa934969.svg";